var map = {
	"./a-file_noaccess.png": 473,
	"./ai.png": 472,
	"./audio.png": 471,
	"./cad.png": 470,
	"./collab-folder.png": 469,
	"./csv.png": 468,
	"./default.png": 467,
	"./doc.png": 466,
	"./external-collab-folder.png": 465,
	"./file-Markdown.png": 464,
	"./file-flow.png": 463,
	"./file-fuse.png": 462,
	"./file-mind.png": 461,
	"./file_unknown.png": 460,
	"./folder-template.png": 459,
	"./folder.png": 458,
	"./html.png": 457,
	"./image.png": 456,
	"./kanban.png": 455,
	"./local.png": 454,
	"./pdf.png": 453,
	"./ppt.png": 452,
	"./project.png": 451,
	"./psd.png": 450,
	"./red.png": 449,
	"./rvt.png": 448,
	"./text.png": 447,
	"./video.png": 446,
	"./visio.png": 445,
	"./xls.png": 444,
	"./zip.png": 443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 474;